
namespace RioERP.Orders {
    export class OrderShippingColumns {
        static columnsKey = 'Orders.OrderShipping';
    }
}